// extracted by mini-css-extract-plugin
export default {"item":"heat_map_item-module___item___ec00c9d7","label":"heat_map_item-module___label___cd70e33a","lightBgColor":"heat_map_item-module___lightBgColor___f2518e24"};